import React from 'react';

const RadioButton = ({ checked, id, label, name, onChange }) => (
  <li data-bem="RadioButton">
    <label data-bem="RadioButton__label" className="radio-btn" htmlFor={id}>
      {label}
      <input data-bem="RadioButton__input" type="radio" id={id} value={name} name={name} checked={checked} onChange={onChange} />
      <span data-bem="RadioButton__checkmark" className="checkmark" />
    </label>
  </li>
);

export default RadioButton;
